import { t } from "i18next";
import * as z from "zod";

/**
 * Schéma du formulaire d'échange de clé de session device
 * (`POST /DeviceSessionKeys/exchange`, guide §6.1 — ⚙️ outillage).
 * Factory mémoïsée au niveau composant sur la langue courante.
 */
export const createDeviceSessionKeyExchangeSchema = () =>
  z.object({
    keycloakUserId: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") }),
    deviceId: z.string().trim().min(1, { message: t("requiredFieldError") }),
    clientPublicKeyBase64: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") }),
    ttlHours: z
      .number({ invalid_type_error: t("invalidFieldError") })
      .int({ message: t("invalidFieldError") })
      .min(1, { message: t("invalidFieldError") })
      .max(720, { message: t("invalidFieldError") }),
  });

export type DeviceSessionKeyExchangeFormValues = z.infer<
  ReturnType<typeof createDeviceSessionKeyExchangeSchema>
>;
